





















import { Component, Vue, Prop } from 'vue-property-decorator';
import { Question } from '@/resource/question/question.model';
import QuestionObjective from '@/components/questions/QuestionObjective.vue';
import QuestionSubjective from '@/components/questions/QuestionSubjective.vue';
import { QuestionLanguage } from '@/resource/subject/subject.model';

@Component({
  components: {
    QuestionObjective,
    QuestionSubjective,
  },
})
export default class QuestionContainer extends Vue {
  @Prop({ required: true })
  question!: Question;

  @Prop({ required: true })
  isObjective!: boolean;

  @Prop({ default: false })
  isWithoutAnswer!: boolean;

  @Prop({ default: false })
  answerPosition!: number | null;

  @Prop({ required: true })
  languages!: QuestionLanguage[];

  @Prop({ default: false })
  isExercise?: boolean;

  @Prop({ required: false })
  selectedAnswer: number;

  selectedAnswerAdd(selectedAnswer: number) {
    this.$emit('selectedAnswerAdd', selectedAnswer);
  }
}
